<template>
  <div class="users">
    <md-progress-bar md-mode="indeterminate" v-if="loading" />
    <div class="users__tabs">
      <div
        class="users__tab"
        :class="{ 'users__tab--active': $route.query.state === 'active' }"
        @click="activateTab('active')"
      >
        Activos
      </div>
      <div
        class="users__tab users__tab--inside"
        :class="{ 'users__tab--active': $route.query.state === 'getdown' }"
        @click="activateTab('getdown')"
      >
        De baja
      </div>
    </div>
    <div class="users__header">
      <div class="users__first">Empleados</div>
      <div class="users__first">Total: {{ $store.state.business.employeesNumber }}</div>
      <div class="users__search">
        <i class="icon-search"></i>
        <input type="text" placeholder="Buscar empleado..." v-model="search" />
      </div>
    </div>
    <router-view
      name="userView"
      :loading="loading"
      @loading="loading = $event"
    ></router-view>
  </div>
</template>

<script>
import Employee from "@/components/empleado/Employee";
import cardEmployee from "@/components/empleado/EmployeeCard";
import { mapGetters, mapActions } from "vuex";
import Paginate from "vuejs-paginate";

import VueContentLoading from "vue-content-loading";

export default {
  components: {
    Employee,
    VueContentLoading,
    Paginate,
    cardEmployee,
    PageEmployee: () => import("@/components/empleado/PageEmployee"),
  },

  created() {
    console.log(this.tabValue, " cambio de tab");
    // this.getEmployees({
    //   id: this.$localStorage.get("businessID"),
    //   state: this.tabValue,
    //   page: this.page,
    // }).then((r) => {
    //   console.log(r);
    //   this.loading = false;
    //   this.pages = r.data.totalPages;
    // });

    // console.log(this.listEmploy)
  },

  data: () => ({
    //loading data
    search: null,
    loading: true,
    showEmployee: null,
    nombres: "jose luis",
    page: 1,
    pages: 1,
    tabValue: "active",
    showDeleteEmployee: false,
    bajaEmployee: {
      name: null,
      reason: null,
      id: null,
      dateEnd: new Date(),
    },
  }),

  computed: {
    ...mapGetters({
      listEmploy: "listEmploy",
    }),
  },

  methods: {
    ...mapActions({
      getEmployees: "getEmployees",
    }),

    employee(index) {
      this.showEmployee = index;
    },
    changePages(page) {
      console.log(page);
      this.loading = true;
      this.getEmployees({
        id: this.$localStorage.get("businessID"),
        state: this.$route.query.state,
        page: page,
      }).then((r) => {
        console.log(r);
        this.pages = r.data.totalPages;
        this.loading = false;
      });
    },
    searchFun() {
      this.loading = true;
      this.getEmployees({
        id: this.$localStorage.get("businessID"),
        search: this.search,
        state: this.$route.query.state,
        page: 1,
      }).then((r) => {
        console.log(r);
        this.pages = r.data.totalPages;
        this.loading = false;
      });
    },
    activateTab(value) {
      console.log(value);
      this.tabValue = value;
      this.$router.push({
        name: "Empleados-lista",
        query: { state: this.tabValue },
      });
    },
    darDeBaja(item) {
      console.log(item);
      this.$set(
        this.bajaEmployee,
        "name",
        `${item.firstName} ${item.firstSurname} ${item.secondSurname}`
      );
      this.$set(this.bajaEmployee, "id", item.id);
      this.showDeleteEmployee = true;
    },
    removeEmployee() {
      this.$toasted.success("dar de baja", {
        theme: "bubble",
        position: "top-right",
        duration: 5000,
        className: "short-message",
      });
      this.showDeleteEmployee = false;
    },
    toLiquidationResume(item) {
      console.log("to liquidacion: ", item);
    },
  },
  watch: {
    search: function (n, o) {
      this.searchFun();
    },
    // $route: function(n, o) {
    //   console.log(n)
    //   this.loading =true
    //   this.getEmployees({
    //     id: this.$localStorage.get("businessID"),
    //     state: n.query.state,
    //     page: this.page,
    //   }).then((r) => {
    //     console.log(r);
    //     this.loading = false;
    //     this.pages = r.data.totalPages;
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

.users {
  // height: 100%;
  padding: 1rem 0.5rem;
  background-color: #eceff8;
  // overflow: auto;
  // overflow-y: scroll;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // flex-wrap: wrap;
  @include mq("800px") {
    height: auto;
    min-height: 100%;
  }
  &__tabs {
    width: 100%;
    height: 2.5rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 1.2rem;
    border-bottom: thin solid rgba(67, 66, 93, 0.5);
  }
  &__tab {
    background-color: #fff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border: thin solid rgba(67, 66, 93, 0.5);
    border-bottom-color: transparent;
    height: 100%;
    font-size: 1rem;
    color: rgba(67, 66, 93, 0.5);
    text-align: center;
    padding: 0.5rem 1.5rem;
    z-index: 0;
    cursor: pointer;
    &--inside {
      margin-left: -14px;
    }
    &--active {
      color: $b-emph;
      border-color: $b-emph;
      border-bottom-color: transparent;
      z-index: 1;
    }
  }
  &__header {
    width: 24rem;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    @include mq($sm) {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
    }
    @include mq("800px") {
      width: auto;
      & > * {
        margin: 0.5rem 1.2rem;
      }
    }
    @include mq($md) {
      justify-content: center;
    }
  }
  &__first {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include mq("800px") {
      width: 16rem;
    }
  }
  &__search {
    background-color: #fff;
    border-radius: 3px;
    margin-top: 1rem;
    padding-left: 0.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    width: 100%;
    @include mq("800px") {
      width: 16rem;
      margin-top: 0.5rem;
    }
    .icon-search {
      margin-right: 1rem;
    }
    input::placeholder {
      color: $b-blue;
    }
  }

  &__body {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    @include mq("800px") {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
    }

    // .container {
    //   width: 24rem;
    //   height: 8rem;
    //   background-color: #fff;
    //   margin-bottom: 1rem;
    //   border-radius: 0.5rem;
    //   @include mq("800px") {
    //     margin: 0.6rem 1.2rem;
    //   }
    //   &__body {
    //     height: 75%;
    //     border-bottom: 1px solid #d7dae2;
    //     display: flex;
    //     justify-content: space-between;
    //     padding: 1rem 1rem 0 1rem;
    //   }
    //   &__img {
    //     height: 3rem;
    //     width: 3rem;
    //     border-radius: 100%;
    //     img {
    //       height: 100%;
    //       width: 100%;
    //       object-fit: cover;
    //     }
    //   }
    //   &__datos {
    //     // margin-left: -0.5rem;
    //     min-width: 200px;
    //     &-nombres {
    //       font-weight: 700;
    //       @include mq($lg) {
    //         cursor: pointer;
    //       }
    //     }
    //     &-cargo {
    //       display: flex;
    //       justify-content: space-between;
    //       color: rgba(#43425d, 0.5);
    //     }
    //     &-fono {
    //       display: flex;
    //       justify-content: space-between;
    //       color: rgba(#43425d, 0.5);
    //     }
    //   }
    //   &__tools {
    //     color: #a4afb7;
    //     .icon-edit {
    //       @include mq($lg) {
    //         cursor: pointer;
    //       }
    //     }
    //     .icon-close {
    //       margin-left: 0.5rem;
    //     }
    //   }
    //   &__footer {
    //     height: 25%;
    //     display: flex;
    //     justify-content: center;
    //     align-items: center;
    //     i {
    //       color: #cecfd0;
    //       font-size: 1.5rem;
    //       margin: 0 1rem;
    //     }
    //   }
    // }
  }
}

.item-loading {
  width: 24rem;
  height: 8rem;
  background-color: white;
  border-radius: 9px;
  margin-bottom: 1rem;
  @include mq("800px") {
    margin: 0.6rem 1.2rem;
  }
}
.field-data {
  max-width: 130px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.nodata-content {
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  img {
    width: 300px;
    margin: 0 auto;
  }
  h5 {
    color: $b-emph;
    margin: 2rem auto;
    font-size: 24px;
  }
}
.employee__actions {
  display: flex;
  justify-content: space-around;
}
.md-dialog {
  z-index: 900;
  padding: 1rem 3rem;
  // max-width: 30rem;
  @include mq($sm) {
    height: 30rem;
    max-height: 46rem;
  }
}
</style>
